import Button from "devextreme-react/button";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function EstimateExitButton() {

	const navigate = useNavigate();
	let [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "/");

	return (
		<Button
			text="Exit"
			icon="Inscyth-Exit"
			elementAttr={{ 'data-testid': 'btn-exit' }}
			type="danger"
			onClick={() => {
				navigate(decodeURIComponent(returnUrl!));
			}} >
		</Button>
	)
}
